import { render, staticRenderFns } from "./BaoCaoTinhHinhDauTu.vue?vue&type=template&id=a3b89aac&scoped=true"
import script from "./BaoCaoTinhHinhDauTu.vue?vue&type=script&lang=ts"
export * from "./BaoCaoTinhHinhDauTu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3b89aac",
  null
  
)

export default component.exports